import {
  FETCH_ACCOUNT_DETAILS_FAILURE,
  FETCH_ACCOUNT_DETAILS_REQUEST,
  FETCH_ACCOUNT_DETAILS_SUCCESS,
  FETCH_ACCOUNT_INFO_FAILURE,
  FETCH_ACCOUNT_INFO_REQUEST,
  FETCH_ACCOUNT_INFO_SUCCESS,
} from "../actions/accountsActions";
import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";

const initialState = {
  account_info: null,
  account_details: null,
  account_info_loading: true,
  account_details_loading:true,
  error: null,
};

const accountsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ACCOUNT_INFO_REQUEST:
      return {
        ...state,
        account_info_loading: true,
        payload: action.payload,
        error: null,
      };
    case FETCH_ACCOUNT_DETAILS_REQUEST:
      return {
        ...state,
        account_details_loading: true,
        error: null,
      };
    case FETCH_ACCOUNT_INFO_SUCCESS:
      return {
        ...state,
        account_info_loading: false,
        account_info: action.payload,
      };
    case FETCH_ACCOUNT_DETAILS_SUCCESS:
      return {
        ...state,
        account_details_loading: false,
        account_details: action.payload,
      };
    case FETCH_ACCOUNT_INFO_FAILURE:
      return { ...state, account_info_loading: false, error: action.payload };
    case FETCH_ACCOUNT_DETAILS_FAILURE:
      return {
        ...state,
        account_details_loading: false,
        error: action.payload,
      };
    case RESET_ALL_ACCOUNT_STATE_DEPEN:
      return {
        ...state,
        account_info_loading: false,
        account_info: null,
      };
    case RESET_ALL_ACCOUNT_STATE_DEPEN:
      return {
        ...state,
        account_details_loading: false,
        account_details: null,
      };
    default:
      return state;
  }
};

export default accountsReducer;
